<script lang="ts">
    import { Link,navigate,Router } from "svelte-navigator";
    import { mediaQuery,user } from "../store/stores";

    export let onClickCallback: (() => any) | undefined;

    const toggleExtendedProfile = () => {
        user.update((user) => {
            return {
                ...user,
                extendedProfile: !user.extendedProfile,
            };
        });
    };
</script>

{#if $mediaQuery.mql.matches}
    {#if $user.authenticated}
        <div class="buttons">
            <button
                class="button is-primary"
                type="submit"
                on:click={() => {
                    onClickCallback();
                    navigate("/profile");
                }}>Mein Profil</button
            >
            <button
                class="button"
                type="submit"
                on:click={() => {
                    $user.logout();
                }}>Logout</button
            >
        </div>
    {/if}
{:else}
    <main class="is-hidden-mobile">
        <div class="card ">
            <header class="card-header level ">
                {#if $user.authenticated}
                    <p class="card-header-title">
                        Hi, {$user.extendedUserData.firstName}!
                    </p>
                    <button
                        class="card-header-icon is-small"
                        on:click={toggleExtendedProfile}
                    >
                        {#if $user.extendedProfile}
                            <span class="icon">
                                <i
                                    class="fas fa-lg fa-user-circle"
                                    aria-hidden="true"
                                />
                            </span>
                        {:else}
                            <span class="icon">
                                <i
                                    class="fas fa-lg fa-user-circle is-large"
                                    aria-hidden="true"
                                />
                            </span>
                        {/if}
                    </button>
                {:else}
                    <p class="card-header-title">Nicht angemeldet.</p>
                    <button class="card-header-icon is-small ">
                        <span class="icon">
                            <i
                                class="fas fa-angle-down"
                                disabled
                                aria-hidden="true"
                            />
                        </span>
                    </button>
                {/if}
            </header>
            {#if $user.extendedProfile && $user.authenticated}
                <div class="card-content">
                    <div class="content">
                        <div class="block">
                            {#if $user.extendedUserData}
                                <Router>
                                    <Link to={"/profile"}>Mein Profil</Link>
                                </Router>
                            {/if}
                        </div>

                        <button
                            class="button"
                            type="submit"
                            on:click={() => {
                                $user.logout();
                            }}>Logout</button
                        >
                    </div>
                </div>
            {/if}
        </div>
    </main>
{/if}

<style>
    main {
        text-align: center;
        padding: 0.2rem;
        width: 15rem;
    }
</style>
